import React, { useState } from 'react'
import { Avatar, Fade, Paper, Theme, Tooltip } from '@mui/material'
import { BACKEND_URL } from '../../../../../../config'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { queryOnlineUsers } from '../../../../../../api/queries'
import { useQuery } from '@tanstack/react-query'
import { IGame } from '../../../../../../api/types/game'
import { fromAxiosError, useGlobalError } from '../../../../../../context/GlobalError'
import { extractMessage } from '../../../../../../utils'
import { ErrorHandler } from '../../../../../../components/ErrorHandler/ErrorHandler'
import { useCableSubscription } from '../../hooks/useCableSubscription'
import { IGameUser } from '../../../../../../api/types/user'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flex: '0 1 auto',
    },
    onlineUsersBox: {
      marginLeft: '4px',
      marginRight: '4px',
      padding: '4px',
      display: 'flex',
    },
    onlineUserBadge: {
      color: theme.palette.mode === 'dark' ? '#32cd32' : '#1b9a1b',
      padding: '4px',
    },
    avatar: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
  })
)

interface Props {
  game: IGame
}

export const OnlineUsers: React.FC<Props> = ({ game }) => {
  const { addError } = useGlobalError()
  const [onlineUsers, setOnlineUsers] = useState<IGameUser[]>([])
  const { isLoading, error } = useQuery<IGameUser[]>(
    ['online_users', game.id],
    () => queryOnlineUsers(game.slug),
    {
      onSuccess: (data: IGameUser[]) => setOnlineUsers(data),
      onError: (err: any) => {
        addError(extractMessage(err) || 'Nie udało się pobrać aktywnych użytkowników', err?.status)
      },
    }
  )

  const handleUserOnlineStateChange = (data: IGameUser) => {
    setOnlineUsers(prev => {
      return [...prev.filter(u => u.id !== data.id), data]
    })
  }

  useCableSubscription('ApplicationCable::OnlineUsersChannel', game.id, handleUserOnlineStateChange)

  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Paper className={classes.onlineUsersBox}>
        <ErrorHandler loading={isLoading} error={fromAxiosError(error)}>
          {onlineUsers &&
            onlineUsers.map(u => (
              <Fade
                key={u.id}
                appear={u.online_status === 'online'}
                in={u.online_status === 'online'}
                unmountOnExit={true}
              >
                <div className={classes.onlineUserBadge}>
                  <Tooltip title={u.user.username} arrow>
                    <Avatar
                      className={classes.avatar}
                      src={u.user.avatar ? BACKEND_URL + u.user.avatar : ''}
                    />
                  </Tooltip>
                </div>
              </Fade>
            ))}
        </ErrorHandler>
      </Paper>
    </div>
  )
}
